<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Button, Container, Row, TabContent, TabPane } from '@sveltestrap/sveltestrap';

  import { ActivityHistory } from '@client/components/activity-history';
  import { AudienceInsights } from '@client/components/audience-insights';
  import { getNotificationsContext } from '@client/components/notifications';

  import { AssetsService } from '@client/services/assets';

  import { VideoEditForm } from './shared';
  import { VideoReport } from './video-report';

  export let data = {};
  export let loading = false;
  export let invalidRulename = false;

  let deleteConfirmation = '';
  let history = [];
  let showDeleteConfirmation = false;

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const navigate = useNavigate();

  const confirmDeletion = async () => {
    loading = true;

    const response = await AssetsService.deleteVideo(data);

    loading = false;

    if (response?.status >= 400) {
      notify($format('label.FAILURE.RULENAME_DELETE', { values: { rulename: data.rulename } }), 'error');

      return;
    }

    notify($format('label.SUCCESS.DELETE', { values: { type: data.rulename } }));

    navigate('/manage/assets/videos');
  };

  const toggleConfirmation = () => (showDeleteConfirmation = !showDeleteConfirmation);
</script>

<div id="edit-video">
  <Container fluid>
    <Row class="pt-3">
      <VideoEditForm bind:data bind:invalidRulename />

      {#if Object.keys(data).length}
        <div class="section">
          <div class="heading">{$format('label.INSIGHTS')}</div>
          <div class="activity-details">
            <VideoReport bind:data bind:loading bind:history />
          </div>
        </div>

        {#if history.length}
          <div class="section">
            <div class="heading">{$format('label.REPORTS')}</div>
            <div class="activity-details">
              <div class="activity-details-tabs">
                <TabContent>
                  <TabPane tabId="history" tab={$format('label.HISTORY')}>
                    <ActivityHistory bind:data={history} />
                  </TabPane>
                  <TabPane tabId="audience" tab={$format('label.AUDIENCE')}>
                    <AudienceInsights row={{ activity: history }} />
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </div>
        {/if}
      {/if}

      <div class="section">
        <div class="delete-group">
          <h2>{$format('label.DELETE')}</h2>
          <p>{@html $format('label.DELETE_WARNING', { values: { type: $format('label.VIDEO').toLowerCase() } })}</p>
          {#if showDeleteConfirmation}
            <div class="delete-confirmation">
              <input
                type="text"
                bind:value={deleteConfirmation}
                placeholder={$format('label.PLACEHOLDER.DELETE', {
                  values: {
                    type: $format('label.VIDEO').toLowerCase(),
                    param: $format('label.NAME').toLowerCase()
                  }
                })}
              />
              <Button color="danger" disabled={deleteConfirmation !== data.rulename} on:click={confirmDeletion}
                >{$format('label.DELETE')}</Button
              >
              <Button color="secondary" on:click={toggleConfirmation}>{$format('label.CANCEL')}</Button>
            </div>
            <small
              >{$format('label.DELETE_REQUIREMENT', {
                values: {
                  type: $format('label.VIDEO').toLowerCase(),
                  param: $format('label.NAME').toLowerCase()
                }
              })}</small
            >
          {:else}
            <Button color="danger" on:click={toggleConfirmation}>{$format('label.DELETE')}</Button>
          {/if}
        </div>
      </div>
    </Row>
  </Container>
</div>

<style lang="scss" src="./edit-video.scss"></style>
